import { Enums } from '@bode-canada/core';
import PropertyTransaction from '@/models/property-transaction';

const HistoryTabsMixin = {
  data() {
    return {
      transactionsDto: [],
    };
  },
  computed: {
    user() {
      return this.$store.state.user.userData;
    },
    latestSoldTransaction() {
      return this.transactions
        .find(({ status }) => (status === Enums.ListingStatusEnum.SOLD));
    },
    transactions() {
      return this.transactionsDto
        .map((transaction) => new PropertyTransaction(transaction, !this.user.isAuthenticated));
    },
    historyTabs() {
      return this.transactions.map((transaction) => ({
        id: transaction.listingId,
        title: `${transaction.status} ${transaction.formattedCloseDate}`,
        description: transaction.formattedPrice,
      }));
    },
  },
};

export default HistoryTabsMixin;
